import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AuthTrackingService } from '@core/services/authTracking.service';
import { RewardService } from '@app/features/rewards/services/reward.service';
import { SurveyService } from './survey.service';
import { ChatService } from './chat.service';

@Injectable()
export class SignOutService {

  constructor(
    private http: HttpClient,
    private authTrackingService: AuthTrackingService,
    private rewards: RewardService,
    private survey: SurveyService,
    private chat: ChatService
  ) { }

  logOut() {
    const payload = {
      refreshToken: this.authTrackingService.getRefreshToken()
    };
    localStorage.removeItem('delivery_address');
    localStorage.removeItem('exclusive_reward_address');
    localStorage.removeItem('exclusive_reward_info');
    // this is a post call that is returned. It can be subscribed against and an response
    // state with messages can be acted upon. Normally this would be the case, but
    // with a signout the client part of the applicaiton is going to treat any response
    // from the server as if the user has signed out regardless
    this.rewards.points = null;
    this.clearQualtricsUserAndScript();
    this.chat.reset();
    return this.http.post('/me/logout', JSON.stringify(payload), { observe: 'response' });
  }
  clearQualtricsUserAndScript() {
    if(typeof window.QSI === 'undefined') {
      window.QSI = {};
    }
    window.QSI.config = {     
      externalReference: ''  
    };
  }
}
